import { IComponentController, ILogService, ITimeoutService } from 'angular'
import { Modal } from 'materialize-css'
import { $candidatoPublicMod } from 'src/_candidato/public/candidato-public-mod'
import { NotificacionService } from '../../../../_panel/module/uni-base/services/NotifService'
import { IFeaturesPubl, IICuestionario, IItemMenu, IModelText } from '../../../../model/candidato-api'
import { AccesoDatos, BASE_CANDIDATO_API } from '../../../comun/services/acceso-datos'

class StartMenuComponentCtrl implements IComponentController {
  idmenu!: number
  version!: string
  params!: { [v: string]: any }
  accesoPublico!: boolean

  appConfig: IFeaturesPubl | null = null

  list: IItemMenu[]
  textosIntro: {
    mostrar: boolean
    validos: boolean
    porlang: {
      [index: string]: IModelText
    }
  } = {
    mostrar: false,
    validos: false,
    porlang: {},
  }

  textosCv = true

  state = {
    menu: null as IItemMenu,
    form: null as IItemMenu,
    form2: null as IItemMenu,
  }

  select = {
    f: null as IICuestionario<any>,
    f2: null as IICuestionario<any>,
    m: null as IItemMenu,
  }

  modalInstance: Modal

  url_logo_azul_cv = `${BASE_CANDIDATO_API}images/Logo_Caxton_azul.jpg`

  constructor(
    private $element: JQLite,
    private $log: ILogService,
    private $timeout: ITimeoutService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[StartMenuComponentCtrl] onInit', this.params)

    let $menuResource = this.AccesoDatos.menuResource

    // $menuResource.findAll().then(listResponse => this.list = listResponse)

    this._callbackMenu().then((response) => {
      this.list = response.options.root
      this.appConfig = response.appconfig

      // textos de introducción
      this.textosCv = response.appconfig.introCv

      // textos modal
      this.textosIntro.mostrar = response.appconfig.dmesg
      if (this.textosIntro.mostrar) {
        if (response.options.intro.es || response.options.intro.en)
          this.textosIntro = {
            validos: true,
            mostrar: true,
            porlang: response.options.intro,
          }
      }

      $('body').addClass(`cand--public cand--public--${this.appConfig.app}`)
    })

    if (this.idmenu) {
      this.selectForm({ idm: this.idmenu } as IItemMenu)
    }
  }

  $postLink() {
    this.$timeout(() => {
      this._initModal()
    }, 1000)
  }

  private _callbackMenu() {
    if (this.accesoPublico) return this.AccesoDatos.MenuPublicos_CLIENT.menuInicioConfigMenusPublicos()
    else return this.AccesoDatos.Menu_CLIENT.menuInicioConfigMenusPrivados()
  }

  private _initModal() {
    let modalInstance = this.$element.find('#modal-wellcome').modal({
      onCloseEnd: () => $('body').removeClass('modal-open').css('overflow', 'auto'),
    })

    // si no está no inicializar
    if (!modalInstance.length) return

    this.modalInstance = M.Modal.getInstance(modalInstance[0])

    if (this.modalInstance) this.modalInstance.open()
  }

  $onDestroy() {
    $('body').removeClass('bg-caxton container-md cand--public')
  }

  selectMain(m1: IItemMenu) {
    this.state.menu = m1
  }

  selectForm(m2: IItemMenu) {
    if (this.version == '1') this.selectFormV1(m2)
    else this.selectFormV2(m2)
  }

  selectFormV1(m2: IItemMenu) {
    // leer el formulario
    this._callbackFormV1(m2) //
      .then((response) => {
        this.select.f = response
        this.select.m = m2
      }) //
      .then(() => (this.state.form = m2))
  }

  selectFormV2(m2: IItemMenu) {
    // leer el formulario
    this._callbackFormV2(m2) //
      .then((response) => {
        this.select.f2 = response
        this.select.m = m2
      }) //
      .then(() => (this.state.form2 = m2))
  }

  private _callbackFormV1(m2: IItemMenu) {
    if (this.accesoPublico) return this.AccesoDatos.FormularPublicos_CLIENT.leerFormularioPublico(m2.idm, m2.idf)
    else return this.AccesoDatos.Formular_CLIENT.leerFormulario(m2.idm, m2.idf)
  }

  private _callbackFormV2(m2: IItemMenu) {
    if (this.accesoPublico) return this.AccesoDatos.FormularPublicos_CLIENT.leerFormularioPublicoDeMenu(m2.idm)
    else return this.AccesoDatos.Formular_CLIENT.leerFormularioDeMenu(m2.idm)
  }

  selectBack() {
    this.state.form = null
    this.state.form2 = null
  }

  toggleDev() {
    $('body').toggleClass('hide__dev')
  }

  closeWellcome() {
    this.modalInstance?.close()
  }
}

$candidatoPublicMod.component('startMenu', {
  bindings: {
    // empresa: "<",
    idmenu: '<',
    test: '<',
    params: '<',
    version: '<',
    accesoPublico: '<',
  },
  controller: StartMenuComponentCtrl,
  template: require('./start-menu.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/start-menu/start-menu.component.html"
})
